<script>
export default {
    name: "Divider",
    props: {
        text: {
            type: String,
            required: false,
            default: 'OR'
        }
    }
}
</script>

<template>
    <div class="d-flex align-items-center my-3">
        <hr class="flex-grow-1">
        <span class="mx-2 text-black">{{ text }}</span>
        <hr class="flex-grow-1">
    </div>
</template>

